import Organization, { Organizations } from 'records/Organization';
import BaseList from 'records/BaseList';

import {
  ORGANIZATIONS_ASYNC_ACTION_START,
  ORGANIZATIONS_ASYNC_ACTION_SUCCESS,
  ORGANIZATIONS_ASYNC_ACTION_ERROR,
} from 'actions/organizations';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: Organizations(),
});

const actionsMap = {
  [ORGANIZATIONS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [ORGANIZATIONS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [ORGANIZATIONS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const orgData = Organization.removeEmptyTextKeys(Organizations(action.data));
    return state.merge({
      loading: false,
      errorMessage: null,
      data: orgData,
    });
  },
};

export default function organizations(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
